import React, { useState, useEffect } from 'react';
import { ListGroup, Accordion } from 'react-bootstrap';
import { getMoreLikeThis } from '../../services';
import CveDocument from '../CveDocument/CveDocument';
import Loading from './Loading';
import DocCard from './DocCard';
import DocCardMitreAttack from '../MitreAttack/DocCardMitreAttack';

const MoreAccordionItem = ({
  docId,
  activeTab,
  profilePrimary,
  profile,
  activeHandler,
  isActive,
  index,
  list,
}) => {
  const [moreLikeThis, setmoreLikeThis] = useState({});
  const [moreLikeThisState, setmoreLikeThisState] = useState(0);
  const [moredocLoader, setMoredocLoader] = useState(false);


  const DocType = ({ type, data }) => {
    switch (type) {
      case 'cve':
        return <MoreCves data={moreLikeThis} />;
      case 'mitre':
        return <MoreMitre data={moreLikeThis} />;
      default:
        return <MoreDocuments data={moreLikeThis} />;
    }
  };
  const MoreCves = ({ data }) => {
    return (
      <div
        className={`ctx-more-like-this ctx-more-cves ${
          moredocLoader ? 'sort-loading-overlay' : ''
        }`}
      >
        <h3>
          Relevant CVE<span>s</span>
        </h3>
        <ListGroup variant='flush'>
          {Object.entries(data).map(([key, value]) => (
            <ListGroup.Item key={value.id}>
              <CveDocument cve={value} />
            </ListGroup.Item>
          ))}
        </ListGroup>
      </div>
    );
  };

  const MoreDocuments = ({ data }) => {
    return (
      <div
        className={`ctx-more-like-this ctx-more-news ${
          moredocLoader ? 'sort-loading-overlay' : ''
        }`}
      >
        {Object.entries(data).map(([key, doc]) => (
          <ListGroup.Item key={doc.id}>
            <DocCard
              doc={doc}
              // Updated to avoid showing both Add and Remove Watchlist buttons simultaneously
              showAddWatchList={list==='recommendations' ? profile.roles.indexOf('curator') > -1 : false}
              list={list}
              showRemove={false}
              profilePrimary={profile}
              key={null}
              cveFields={[]}
              hidePlaceholderImage={true}
              showTags={false}
              showCuratorAction={(list === 'watchlist' || list === 'advance-search' ) ? true : false}
              //allTags={searchOptions}
              //selectedTags={selectedSearchValue.map((t) => t.name)}
            />
          </ListGroup.Item>
        ))}
      </div>
    );
  };

  const MoreMitre = ({ data }) => {
    return (
      <div
        className={`ctx-more-like-this ctx-more-mitre ${
          moredocLoader ? 'sort-loading-overlay' : ''
        }`}
      >
        {Object.entries(data).map(([key, doc]) => (
          <ListGroup.Item key={doc.id}>
            <DocCardMitreAttack
              doc={doc}
              showAddWatchList={false}
              list={list}
              showRemove={false}
              profilePrimary={profile}
              key={null}
              showTags={false}
              //allTags={searchOptions}
              //selectedTags={selectedSearchValue.map((t) => t.name)}
            />
          </ListGroup.Item>
        ))}
      </div>
    );
  };

  useEffect(() => {
    setmoreLikeThisState(1);

    if (isActive) {
      setMoredocLoader(true);
      getMoreLikeThis([docId], profilePrimary, profile).then((finalResult) => {

        if (finalResult) {
          setmoreLikeThis(finalResult.documents);
          setmoreLikeThisState(0);
          setMoredocLoader(false);
        } else {
          setmoreLikeThisState(0);
          setMoredocLoader(false);
        }
      });
    } else {
      //setmoreLikeThisState(0)
      //setContents(null);
      //setContentsState(0);
    }
  }, [isActive, docId, profilePrimary, profile]);

  return (
    <Accordion.Item eventKey={index}>
      <Accordion.Header onClick={() => activeHandler(index)}>
        {profile.repositoryName}
      </Accordion.Header>
      <Accordion.Body>
        {moreLikeThisState === 1 && (
          <Loading text='Finding Related Documents...' />
        )}
        {moreLikeThis && moreLikeThis.length ? (
          <DocType type={profile.type} data={moreLikeThis} />
        ) : null}
      </Accordion.Body>
    </Accordion.Item>
  );
};

const MoreLikeThis = ({ docId, profilePrimary, profileSecondary, list }) => {
  const [activeTab, setActiveTab] = useState(null);
  const toggleActive = (tabIndex) => {
    setActiveTab(tabIndex);
  };

  return (
    <Accordion flush defaultActiveKey={activeTab}>
      {profileSecondary &&
        profileSecondary.length &&
        profileSecondary.map((profile, i) => (
          <MoreAccordionItem
            docId={docId}
            profilePrimary={profilePrimary}
            profile={profile}
            activeHandler={toggleActive}
            isActive={activeTab === i}
            index={i}
            key={`tab-${i}`}
            list={list}
          />
        ))}
    </Accordion>
  );
};
export default MoreLikeThis;
